// |--------------------------------------------------------------------------
// |Auth ログイン機能
// |--------------------------------------------------------------------------
// |
// | ここではログインのapiを例として記述しています。
// | ログインで使用するapiを全て記述します。
// | このapiを親のjs（functionApi.js）でimportして使用します。

/* ---------------------------------------------------------------------------
  サインイン
---------------------------------------------------------------------------- */
export const signIn = async data => {
	return await axios.post(`/api/auth/sign_in`, data);
};
/* ---------------------------------------------------------------------------
  サインアウト
---------------------------------------------------------------------------- */
export const logout = async data => {
	return await axios.post(`/api/auth/sign_out`);
};
